export const pause = async (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const delay = async (fn, ms) => {
	await pause(ms)
	await fn()
}
